import { useSlots as v, openBlock as n, createBlock as r, withCtx as o, createVNode as a, createTextVNode as i, toDisplayString as m, createCommentVNode as f, unref as l, renderSlot as c, createElementBlock as C, withModifiers as g } from "vue";
import D from "./design-system.es16.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import x from "./design-system.es39.js";
import p from "./design-system.es108.js";
/* empty css                    */
import O from "./design-system.es62.js";
/* empty css                    */
/* empty css                    */
import z from "./design-system.es116.js";
import L from "./design-system.es94.js";
import y from "./design-system.es106.js";
const $ = { key: 2 }, Q = /* @__PURE__ */ Object.assign({
  name: "DsConfirmDialog"
}, {
  __name: "ConfirmDialog",
  props: {
    /**
     * Controls the open state of the modal.
     */
    isOpen: Boolean,
    /**
     * Title of the modal
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Message contained in the modal
     */
    message: String,
    /**
     * The label for the confirm button
     */
    confirmLabel: String,
    /**
     * The label for the cancel button
     */
    cancelLabel: String,
    /**
     * Omits the cancel button
     */
    confirmOnly: Boolean,
    /**
     * Styles the dialog to be destructive
     */
    destructive: Boolean,
    /**
     * Determines the size of the modal
     */
    size: {
      type: String,
      default: "xs",
      options: ["xs", "sm", "med"]
    }
  },
  emits: ["cancel", "confirm"],
  setup(t, { emit: k }) {
    const u = k, d = v(), b = z();
    function S() {
      u("cancel");
    }
    function B() {
      u("confirm");
    }
    return (s, e) => (n(), r(D, {
      "is-open": t.isOpen,
      dialog: "",
      class: "confirm-modal",
      size: t.size
    }, {
      default: o(() => [
        a(L, {
          fill: "",
          space: "spacing-200"
        }, {
          default: o(() => [
            t.title ? (n(), r(y, {
              key: 0,
              variant: "headline-1",
              as: "h4"
            }, {
              default: o(() => [
                i(m(t.title), 1)
              ]),
              _: 1
            })) : f("", !0),
            e[1] || (e[1] = i()),
            l(d).message || t.message ? (n(), r(y, {
              key: 1,
              variant: "body",
              as: "p"
            }, {
              default: o(() => [
                c(s.$slots, "message", {}, () => [
                  i(m(t.message), 1)
                ])
              ]),
              _: 3
            })) : f("", !0),
            e[2] || (e[2] = i()),
            l(d).default ? (n(), C("div", $, [
              c(s.$slots, "default")
            ])) : f("", !0),
            e[3] || (e[3] = i()),
            a(O, {
              fill: "",
              "align-x": "right"
            }, {
              default: o(() => [
                a(x, null, {
                  default: o(() => [
                    c(s.$slots, "cancel", {}, () => [
                      t.confirmOnly ? f("", !0) : (n(), r(l(p), {
                        key: 0,
                        gray: "",
                        class: "cancel-button",
                        onClick: g(S, ["stop"])
                      }, {
                        default: o(() => [
                          i(m(t.cancelLabel || l(b).messages["modal.cancel.button"]), 1)
                        ]),
                        _: 1
                      }))
                    ]),
                    e[0] || (e[0] = i()),
                    c(s.$slots, "confirm", {}, () => [
                      a(l(p), {
                        destructive: t.destructive,
                        class: "confirm-button",
                        onClick: g(B, ["stop"])
                      }, {
                        default: o(() => [
                          i(m(t.confirmLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["destructive"])
                    ])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["is-open", "size"]));
  }
});
export {
  Q as default
};
//# sourceMappingURL=design-system.es14.js.map
